import { gql } from "@apollo/client";

// eslint-disable-next-line import/prefer-default-export
export const GET_MANY_NOTIFICATIONS = gql`
  query getManyNotifications($where: NotificationWhereInput) {
    notifications: getManyNotifications(where: $where) {
      id
      Data
      FK_Place
      FK_Module
      Created_At
      Updated_At
      State_Notification
      Notification_User {
        id
        Readed_At
      }
    }
  }
`;
